import { useTheme } from '@mui/material';

export const QuickStudyIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} fill="none">
            <path
                fill={primaryStroke}
                d="m28.969 19.525 2.212-8.412L32 8l-2.575 1.931L12 23v3l5.519.369 2.031.137-.519 1.969-2.212 8.413L16 40l2.575-1.931L36 25v-3l-5.519-.369-2.031-.137.519-1.969ZM34 23.869V24L19.394 34.95l2.087-7.938.619-2.343-2.413-.163L14 24.125v-.131L28.606 13.05l-2.087 7.938-.619 2.343 2.419.163 5.687.381-.006-.006Z"
            />
        </svg>
    );
};
